import React, { useState, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import MinecraftCharacter from './MinecraftCharacter';

interface SkinViewerProps {
    skins: { skinUrl: string; skinName: string }[];
}

export default function SkinViewer({ skins }: SkinViewerProps) {
    const [selectedSkin, setSelectedSkin] = useState<{ skinUrl: string; skinName: string } | null>(null);

    useEffect(() => {
        if (skins.length > 0) {
            setSelectedSkin(skins[0]);
        }
    }, [skins]);

    return (
        <div style={{ position: 'relative', width: '100%', height: '500px' }}>
            {/* 스킨 선택 버튼들 */}
            <div className="absolute top-0 left-0 w-full flex space-x-2 mb-4 p-2 z-10">
                {skins.map((skin) => (
                    <button
                        key={skin.skinName}
                        onClick={() => setSelectedSkin(skin)}
                        className={`pl-2 pr-2 h-8 bg-gray-800 text-white rounded-lg border-2 flex items-center justify-center cursor-pointer mb-2 ${selectedSkin?.skinName === skin.skinName ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                    >
                        {skin.skinName}
                    </button>
                ))}
            </div>

            <Canvas style={{ width: '100%', height: '100%' }}>
                <ambientLight intensity={0.5} />
                <directionalLight position={[2, 2, 2]} />
                <OrbitControls enableZoom={true} />
                {selectedSkin && (
                    <MinecraftCharacter textureUrl={selectedSkin.skinUrl} />
                )}
            </Canvas>
        </div>
    );
}
